import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: {
    },
})

export default class AvisoLegalWeb extends Vue {

    public created() {
        document.documentElement.scrollTop; 
    }

    public get language() {
        return this.$root.$i18n.locale.toString();
    }

}